import {
  GET_SENSOR_CHART_FAILURE,
  GET_SENSOR_CHART_REQUEST,
  GET_SENSOR_CHART_SUCCESS,
  GET_SENSOR_FULL_CHART_FAILURE,
  GET_SENSOR_FULL_CHART_REQUEST,
  GET_SENSOR_FULL_CHART_SUCCESS,
  GET_SENSOR_METRICS_FAILURE,
  GET_SENSOR_METRICS_REQUEST,
  GET_SENSOR_METRICS_SUCCESS,
  RESET_SENSOR_DETAILS,
} from './SensorDetails.constant';
import { ISensorDetails, SensorDetailsActionTypes } from './SensorDetails.type';

const initialState: ISensorDetails = {
  metrics: {
    items: [],
    sensor: null,
    meta: {
      limit: 0,
      page: 0,
      pages: 0,
      skip: 0,
      total: 0,
    },
  },
  chartData: null,
  fullChartData: null,

  isLoading: false,
  isChartLoading: false,
  isMetricsLoading: false,
};

export default function sensorDetailsReducer(
  state = initialState,
  action: SensorDetailsActionTypes,
): ISensorDetails {
  switch (action.type) {
    case GET_SENSOR_CHART_REQUEST:
    case GET_SENSOR_FULL_CHART_REQUEST:
      return { ...state, isChartLoading: true };

    case GET_SENSOR_CHART_SUCCESS:
      return { ...state, isChartLoading: false, chartData: action.payload };

    case GET_SENSOR_FULL_CHART_SUCCESS:
      return { ...state, isChartLoading: false, fullChartData: action.payload };

    case GET_SENSOR_CHART_FAILURE:
    case GET_SENSOR_FULL_CHART_FAILURE:
      return { ...state, isChartLoading: false };

    case GET_SENSOR_METRICS_REQUEST:
      return { ...state, isMetricsLoading: true };
    case GET_SENSOR_METRICS_SUCCESS:
      return { ...state, metrics: action.payload, isMetricsLoading: false };
    case GET_SENSOR_METRICS_FAILURE:
      return { ...state, isMetricsLoading: false };

    case RESET_SENSOR_DETAILS:
      return { ...initialState };

    default:
      return { ...state };
  }
}
